module.exports = __webpack_public_path__ + "img/appIcon-menu--Integrations.83879f2e.svg";